import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1165ef8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-menu-portal-container" }
const _hoisted_2 = { class: "ampc--header-container" }
const _hoisted_3 = {
  "data-testid": "action-menu-portal-title",
  class: "ibf-gordita-12-m"
}
const _hoisted_4 = { class: "ampc--body-container" }
const _hoisted_5 = ["seperator"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ibf-gordita-12-m" }, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_incredi_button = _resolveComponent("incredi-button")!
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ])
    ], true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _renderSlot(_ctx.$slots, "footer", {}, () => [
      _createElementVNode("div", {
        class: "ampc--footer-container",
        seperator: _ctx.seperator.toString()
      }, [
        _createVNode(_component_incredi_button, _mergeProps(_ctx.attrsComputed, {
          padding: "2px 8px",
          class: "ampc--submit-btn",
          "data-testid": "action-menu-portal-button",
          "text-color": 'white',
          "background-color": _ctx.attrsComputed.disable ? _ctx.COLORS['Status/status_offline'] : _ctx.COLORS['System/app_primary'],
          onKeydown: _cache[0] || (_cache[0] = (event) => _ctx.keyDownA11y(event, () => _ctx.$emit('submit'))),
          onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('submit'))
        }), {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 16, ["background-color"])
      ], 8, _hoisted_5)
    ], true)
  ])), [
    [_directive_incredi_focus_trap, 'action-menu-portal']
  ])
}